// WP フォームの表示制御のための固有スクリプト
// 内容は主に中園さん指定によるもの
jQuery(function ($) {
  $(function () {
    $(".form-row:has('span.error')").addClass("-error");
    $(".mw_wp_form_confirm .field").addClass("content").removeClass("field");
    $(".mw_wp_form_confirm h2.label").addClass(" -confirm");
  });
});